module.exports = __webpack_public_path__ + "img/CEV2505.84bbaf68.png";